import Vue from 'vue'
import VueRouter from 'vue-router'
import Homeindex from '@/views/index.vue'
import Payindex from '@/views/pay.vue'
import Liveindex from '@/views/live.vue'
import liveCenter from '@/views/liveCenter.vue'
import Book from '@/views/book.vue'
import Profile from '@/views/profile.vue'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    component: Homeindex,
    meta: { title: 'index' }
   
  },
  {
    path: '/profile',
    name: 'profile',
    component: Profile,
    meta: { title: 'profile' }
   
  },
  {
    path: '/book',
    name: 'book',
    component: Book,
    meta: { title: 'book' }
   
  },
  {
    path: '/pay',
    name: 'pay',
    component: Payindex,
    meta: { title: 'pay' }
   
  },
  {
    path: '/live',
    name: 'live',
    component: Liveindex,
    meta: { title: 'live' }
   
  },
  {
    path: '/liveCenter',
    name: 'liveCenter',
    component: liveCenter,
    meta: { title: 'liveCenter' }
   
  },
  {
    path: '/detail',
    name: 'Detail',
    component: () => import('../views/detail.vue')
  },
  {
    path: '/reader',
    name: 'Reader',
    component: () => import('../views/reader.vue'),
    meta: { title: '小说阅读' }
  },
  {
    path: '/shortvideo',
    name: 'ShortVideo',
    component: () => import('../views/shortvideo.vue'),
    meta: { title: 'AI短剧' }
  }
];

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})




export default router
